import React from 'react'

import formatAxisValueAs from '../../util/formatAxisValueAs'
import grooveTheme from '../../grooveTheme'
import ProgressBarIndividual from './ProgressBarIndividual'
import styles from './styles.less'

export default function ProgressBarView({
  colorScale = grooveTheme.colors.scale,
  dataSets,
  scale,
  total: propTotal,
}) {
  return (
    <section className={styles.ProgressBars}>
      {dataSets.map(({ data, timeframe }, dsIndex) => {
        const total =
          propTotal ||
          data.reduce((runningTotal, datum) => {
            if (typeof datum.y === 'number') return runningTotal + datum.y
            return runningTotal
          }, 0)
        return data.map((datum, index) => {
          const colorIndex =
            (dataSets
              .slice(0, dsIndex)
              .reduce((count, dataSet) => count + dataSet.data.length, 0) +
              index) %
            colorScale.length
          const color = colorScale[colorIndex]
          return (
            <ProgressBarIndividual
              color={color}
              key={datum.id || `pb-${dsIndex}-${index}`}
              scale={scale}
              timeframe={timeframe}
              title={`${
                datum.x || datum.x === 0
                  ? `${formatAxisValueAs(scale.formatXAs || scale.x, datum.x)}`
                  : ''
              }`}
              total={total}
              value={datum.y}
            />
          )
        })
      })}
    </section>
  )
}
